import React from 'react'
import { toast } from 'react-toastify'

import { Button } from '@clientbase/clientbase-library'
import { useAuthContext } from 'context/AuthContext'
import copy from 'copy-to-clipboard'

type CopyLinkFieldProps = {
  onCopy?: () => void
}

const CopyLinkField = ({ onCopy }: CopyLinkFieldProps) => {
  const { user } = useAuthContext()
  const link = `https://base.clientbase.com.br/registrar?merchant_referral_uuid=${user?.uuid}`

  const handleCopy = () => {
    copy(link)
    toast.success(`Link copiado com sucesso.`)
    onCopy && onCopy()
  }

  return (
    // Sobre o Mint Wash do card o primário (mint) se destaca como a ação principal
    <Button
      fullWidth
      variantButton="primary"
      onClick={handleCopy}
      startIcon="faLink"
    >
      Copiar link
    </Button>
  )
}

export default CopyLinkField
